import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Modal,
  Steps,
  Form,
  Input,
  Select,
  DatePicker,
  Dropdown,
  Menu,
  Row,
  Col,
  Radio,
  Tag,
} from "antd";
import { MoreOutlined } from "@ant-design/icons";
// import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { fetchBranches } from "../../Redux/Slice/Admin/Branch";
import { fetchDoctors } from "../../Redux/Slice/Admin/Doctor";
import { fetchDoctorAvailability } from "../../Redux/Slice/Doctor/Slots";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import {
  createBookingByRecp,
  fetchBookingByRecp,
  searchBookingByRecp,
} from "../../Redux/Slice/Patient/Booking";
import RescheduleBookingModal from "./RescheduleBooking";
import CancelBookingModal from "./CancelBooking";

const statusColors = {
  Confirmed: "green",
  Unconfirmed: "orange",
  Active: "blue",
  Ended: "red",
  AutoEnded: "volcano",
  Rejected: "red",
};

const { Step } = Steps;
const { Option } = Select;

const BookingDashboard = () => {
  const dispatch = useDispatch();
  const [bookings, setBookings] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [form] = Form.useForm();
  const [specialities, setSpecialities] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [availability, setAvailability] = useState(null);
  const [rescheduleModal, setRescheduleModal] = useState({
    open: false,
    record: null,
  });
  const [cancelModal, setCancelModal] = useState({ open: false, record: null });
  const [filters, setFilters] = useState({
    fromDate: null,
    toDate: null,
    doctorName: null,
    // specialityId: null,
    patientName: "",
  });
  const [isSearchActive, setIsSearchActive] = useState(false);

  const selectedBranchIdRaw = localStorage.getItem("selectedBranchId");
  // normalize branch id to number (or null)
  const selectedBranchId = selectedBranchIdRaw
    ? Number(selectedBranchIdRaw)
    : null;

  const { data: branchData } = useSelector((state) => state.branch.fetch);
  const { data: doctorData, loading: doctorLoading } = useSelector(
    (state) => state.doctor.fetch
  );
  const { data, loading } = useSelector(
    (state) => state.booking?.fetchrecepData
  );

  const { data: searchData, loading: searchLoading } = useSelector(
    (state) => state.booking?.searchrecepData
  );

  console.log("searchData", searchData);

  const handleSearch = () => {
    setIsSearchActive(true);
    dispatch(searchBookingByRecp({ ...filters, branchId: selectedBranchId }));
  };

  useEffect(() => {
    if (isSearchActive) {
      if (searchData?.status) {
        setBookings(searchData?.data || []);
      } else {
        // even if no data found, show empty table
        setBookings([]);
      }
    }
  }, [searchData, isSearchActive]);

  const handleReset = () => {
    setIsSearchActive(false);
    setFilters({
      fromDate: null,
      toDate: null,
      doctorName: null,
      // specialityId: null,
      patientName: "",
    });

    // Reset to original data
    dispatch(fetchBookingByRecp({ branchId: selectedBranchId })).then(() => {
      const filtered = selectedBranchId
        ? data?.data?.filter(
            (b) =>
              b.branch?.branchId?.toString() === selectedBranchId?.toString()
          )
        : data?.data;
      setBookings(filtered || []);
    });
  };

  useEffect(() => {
    if (!isSearchActive && data?.status) {
      const filtered = selectedBranchId
        ? data?.data?.filter(
            (b) =>
              b.branch?.branchId?.toString() === selectedBranchId?.toString()
          )
        : data?.data;
      setBookings(filtered || []);
    }
  }, [data, selectedBranchId, isSearchActive]);

  useEffect(() => {
    dispatch(fetchDoctors());
    dispatch(fetchBranches());
  }, [dispatch]);

  useEffect(() => {
    // fetch bookings scoped to branch if branch selected
    if (selectedBranchId) {
      dispatch(fetchBookingByRecp({ branchId: selectedBranchId }));
    } else {
      dispatch(fetchBookingByRecp());
    }
  }, [dispatch, selectedBranchId]);

  const [bookingData, setBookingData] = useState({
    name: "",
    // phoneNo: "",
    emailId: "",
    // gender: "",
    // age: "",
    // dob: null,
    // maritalStatus: "",
    // nationalId: "",
    doctorId: null,
    branchId: selectedBranchId, // injected automatically
    specialityId: null,
    appointmentDate: null,
    appointmentTime: "",
    timeInterval: "15",
    scheduleType: "",
    callType: "Video",
  });

  // When branch data loads or selectedBranchId changes, populate specialities
  useEffect(() => {
    if (selectedBranchId && branchData?.data) {
      const branch = branchData.data.find(
        (b) => Number(b.branchId) === Number(selectedBranchId)
      );
      if (branch) {
        setSpecialities(branch.specialities || []);
        setBookingData((prev) => ({
          ...prev,
          branchId: Number(selectedBranchId),
          specialityId: null,
          doctorId: null,
        }));
      } else {
        setSpecialities([]);
        setBookingData((prev) => ({
          ...prev,
          branchId: Number(selectedBranchId) || null,
          specialityId: null,
          doctorId: null,
        }));
      }
    } else if (branchData?.data && !selectedBranchId) {
      // no branch selected: clear specialities
      setSpecialities([]);
      setBookingData((prev) => ({
        ...prev,
        branchId: null,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBranchId, branchData]);

  // filtered doctors based on branchId & specialityId
  const filteredDoctors =
    doctorData?.data?.filter(
      (doc) =>
        (bookingData.branchId
          ? doc.branchIds?.includes(Number(bookingData.branchId))
          : true) &&
        (bookingData.specialityId
          ? doc.specialtyIds?.includes(Number(bookingData.specialityId))
          : true)
    ) || [];

  // when date changes
  const handleDateChange = (date) => {
    if (!date) {
      setBookingData((prev) => ({ ...prev, appointmentDate: null }));
      setAvailability(null);
      return;
    }

    const selectedDate = date.format("YYYY-MM-DD");
    setBookingData((prev) => ({ ...prev, appointmentDate: selectedDate }));

    if (bookingData.doctorId) {
      dispatch(
        fetchDoctorAvailability({
          doctorId: bookingData.doctorId,
          interval: 15,
          selectedDate,
        })
      ).then((res) => {
        if (res?.payload) {
          setAvailability(res.payload);
        } else {
          setAvailability(null);
        }
      });
    }
  };

  // When doctor changes, reset availability and appointment time/date
  const handleDoctorChange = (docId) => {
    setBookingData((prev) => ({
      ...prev,
      doctorId: docId,
      appointmentDate: null,
      appointmentTime: "",
      scheduleType: "",
    }));
    setAvailability(null);
  };

  const steps = [
    {
      title: "Patient Details",
      content: (
        <Form layout="vertical" form={form}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Name" required>
                <Input
                  value={bookingData.name}
                  onChange={(e) =>
                    setBookingData({ ...bookingData, name: e.target.value })
                  }
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Email ID" required>
                <Input
                  value={bookingData.emailId}
                  onChange={(e) =>
                    setBookingData({ ...bookingData, emailId: e.target.value })
                  }
                />
              </Form.Item>
            </Col>

            {/*  <Col span={12}>
              <Form.Item label="Phone No" required>
                <Input
                  value={bookingData.phoneNo}
                  onChange={(e) =>
                    setBookingData({ ...bookingData, phoneNo: e.target.value })
                  }
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item label="Gender" required>
                <Select
                  value={bookingData.gender}
                  onChange={(value) =>
                    setBookingData({ ...bookingData, gender: value })
                  }
                >
                  <Option value="Male">Male</Option>
                  <Option value="Female">Female</Option>
                  <Option value="Other">Other</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Age" required>
                <Input
                  type="number"
                  value={bookingData.age}
                  onChange={(e) =>
                    setBookingData({ ...bookingData, age: e.target.value })
                  }
                />
              </Form.Item>
            </Col>
            */}
          </Row>
        </Form>
      ),
    },
    {
      title: "Doctor Details",
      content: (
        <Form layout="vertical" form={form}>
          <Row gutter={16}>
            {/* Branch field removed - branch injected from localStorage */}

            <Col span={12}>
              <Form.Item label="Speciality" required>
                <Select
                  value={bookingData.specialityId}
                  onChange={(value) =>
                    setBookingData({
                      ...bookingData,
                      specialityId: value,
                      doctorId: null,
                    })
                  }
                  placeholder="Select Speciality"
                >
                  {specialities.map((spec) => (
                    <Option key={spec.specialityId} value={spec.specialityId}>
                      {spec.specialityName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item label="Doctor" required>
                <Select
                  value={bookingData.doctorId}
                  onChange={(value) => handleDoctorChange(value)}
                  placeholder="Select Doctor"
                  loading={doctorLoading}
                >
                  {filteredDoctors.map((doc) => (
                    <Option key={doc.doctorId} value={doc.doctorId}>
                      {doc.firstName} {doc.lastName || ""}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      ),
    },
    {
      title: "Date & Time",
      content: (
        <Form layout="vertical" form={form}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Appointment Date" required>
                <DatePicker
                  style={{ width: "100%" }}
                  onChange={handleDateChange}
                  disabledDate={(current) =>
                    current && current < dayjs().startOf("day")
                  }
                  value={
                    bookingData.appointmentDate
                      ? dayjs(bookingData.appointmentDate, "YYYY-MM-DD")
                      : null
                  }
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="Available Time Slots" required>
                {availability ? (
                  Object.keys(availability).map((session) => (
                    <div key={session} style={{ marginBottom: "16px" }}>
                      <h4
                        style={{
                          marginBottom: "8px",
                          textTransform: "capitalize",
                        }}
                      >
                        {session}
                      </h4>
                      <Radio.Group
                        value={bookingData.appointmentTime}
                        onChange={(e) => {
                          const selectedTime = e.target.value;
                          setBookingData({
                            ...bookingData,
                            appointmentTime: selectedTime,
                            scheduleType: session,
                          });
                        }}
                      >
                        {availability[session]?.available?.map((slot, idx) => {
                          const slotTime = dayjs(
                            `${
                              bookingData.appointmentDate
                            } ${slot.start.toUpperCase()}`,
                            "YYYY-MM-DD hh:mm A"
                          );

                          const isPast = slotTime.isBefore(dayjs());
                          const isBooked = slot.booked === true;

                          return (
                            <Radio.Button
                              key={idx}
                              value={slot.start}
                              style={{ margin: "4px" }}
                              disabled={isPast || isBooked}
                            >
                              {slot.start}
                            </Radio.Button>
                          );
                        })}
                      </Radio.Group>
                    </div>
                  ))
                ) : (
                  <p style={{ color: "#888" }}>
                    Select doctor and date to view slots
                  </p>
                )}
              </Form.Item>
            </Col>
          </Row>
        </Form>
      ),
    },
  ];

  const next = () => setCurrentStep((prev) => prev + 1);
  const prev = () => setCurrentStep((prev) => prev - 1);

  const handleSubmit = () => {
    setSubmitting(true);

    // ensure branchId is included and numeric
    const payload = {
      ...bookingData,
      branchId: bookingData.branchId ? Number(bookingData.branchId) : null,
    };

    dispatch(createBookingByRecp(payload))
      .then(() => {
        toast.success("Booking created successfully!");
        // refresh bookings for the branch
        if (selectedBranchId) {
          dispatch(fetchBookingByRecp({ branchId: selectedBranchId }));
        } else {
          dispatch(fetchBookingByRecp());
        }
        setIsModalOpen(false);
        setCurrentStep(0);
        // reset but keep branchId
        setBookingData({
          // name: "",
          phoneNo: "",
          emailId: "",
          // gender: "",
          // age: "",
          // dob: null,
          // maritalStatus: "",
          // nationalId: "",
          // doctorId: null,
          // branchId: selectedBranchId || null,
          // specialityId: null,
          // appointmentDate: null,
          // appointmentTime: "",
          // timeInterval: "15",
          // scheduleType: "",
          // callType: "Video",
        });
        setAvailability(null);
      })
      .catch((err) => {
        // optional: show error message returned by API
        toast.error("Failed to create booking");
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  // WhatsApp Share
  const handleShare = (record) => {
    const text = `Booking Details:
Patient: ${record.patient?.name}
Phone: ${record.patient?.phoneNo}
Doctor: ${record.doctor?.name}
Speciality: ${record.doctor?.speciality}
Branch: ${record.branch?.branchName}
Date: ${record.appointmentDate}
Time: ${record.appointmentTime}
Call Type: ${record.callType}
Join Link: ${record.videoCallRoom?.joinLink || "N/A"}`;

    const url = `https://wa.me/?text=${encodeURIComponent(text)}`;
    window.open(url, "_blank");
  };

  const actionMenu = (record) => (
    <Menu
      items={[
        {
          key: "reschedule",
          label: "Reschedule",
          onClick: () => setRescheduleModal({ open: true, record }),
        },
        {
          key: "cancel",
          label: "Cancel",
          onClick: () => setCancelModal({ open: true, record }),
        },
        {
          key: "share",
          label: "Share (WhatsApp)",
          onClick: () => handleShare(record),
        },
      ]}
    />
  );

  const columns = [
    {
      title: "S No",
      dataIndex: "sno",
      key: "sno",
      render: (_, r, i) => i + 1,
    },
    { title: "Patient", dataIndex: ["patient", "name"], key: "name" },
    { title: "Doctor", dataIndex: ["doctor", "name"], key: "doctor" },
    {
      title: "Speciality",
      dataIndex: ["doctor", "speciality"],
      key: "speciality",
    },
    { title: "Branch", dataIndex: ["branch", "branchName"], key: "branch" },
    { title: "Date", dataIndex: "appointmentDate", key: "appointmentDate" },
    { title: "Time", dataIndex: "appointmentTime", key: "appointmentTime" },
    {
      title: "Duration",
      dataIndex: ["videoCallRoom", "durationSeconds"],
      key: "videoCallRoom",
    },
    {
      title: "Call Status",
      dataIndex: "confirmStatus",
      key: "confirmStatus",
      render: (status) => (
        <Tag color={statusColors[status] || "default"}>{status}</Tag>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => {
        const status = record.confirmStatus;

        if (status === "Ended" || status === "AutoEnded") {
          return <span style={{ color: "#999" }}>No Actions</span>;
        }

        return (
          <Dropdown overlay={actionMenu(record)} trigger={["click"]}>
            <Button icon={<MoreOutlined />} />
          </Dropdown>
        );
      },
    },
  ];

  return (
    <div style={{ padding: 24, background: "#f9f9f9", minHeight: "100vh" }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h2>Booking List</h2>
        <Button
          type="primary"
          onClick={() => {
            // ensure branchId present in bookingData before opening modal
            setBookingData((prev) => ({
              ...prev,
              branchId: selectedBranchId || prev.branchId,
            }));
            setIsModalOpen(true);
          }}
        >
          Create Booking
        </Button>
      </div>

      {/* 🔍 Search Filters */}
      <div
        style={{
          background: "#fff",
          padding: "16px",
          borderRadius: "8px",
          marginTop: "16px",
          marginBottom: "16px",
        }}
      >
        <Form
          layout="vertical"
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "16px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "16px",
              width: "100%",
            }}
          >
            <Form.Item label="From Date" style={{ flex: "1 1 160px" }}>
              <DatePicker
                style={{ width: "100%" }}
                value={
                  filters.fromDate
                    ? dayjs(filters.fromDate, "YYYY-MM-DD")
                    : null
                }
                onChange={(date) =>
                  setFilters((prev) => ({
                    ...prev,
                    fromDate: date ? date.format("YYYY-MM-DD") : null,
                  }))
                }
              />
            </Form.Item>

            <Form.Item label="To Date" style={{ flex: "1 1 160px" }}>
              <DatePicker
                style={{ width: "100%" }}
                value={
                  filters.toDate ? dayjs(filters.toDate, "YYYY-MM-DD") : null
                }
                onChange={(date) =>
                  setFilters((prev) => ({
                    ...prev,
                    toDate: date ? date.format("YYYY-MM-DD") : null,
                  }))
                }
              />
            </Form.Item>

            {/* <Form.Item label="Speciality" style={{ flex: "1 1 180px" }}>
              <Select
                placeholder="Select Speciality"
                allowClear
                value={filters.specialityId}
                onChange={(value) =>
                  setFilters((prev) => ({ ...prev, specialityId: value }))
                }
              >
                {specialities.map((spec) => (
                  <Option key={spec.specialityId} value={spec.specialityId}>
                    {spec.specialityName}
                  </Option>
                ))}
              </Select>
            </Form.Item> */}

            <Form.Item label="Doctor" style={{ flex: "1 1 180px" }}>
              <Select
                placeholder="Select Doctor"
                allowClear
                value={filters.doctorName}
                onChange={(value) =>
                  setFilters((prev) => ({ ...prev, doctorName: value }))
                }
              >
                {filteredDoctors.map((doc) => (
                  <Option key={doc.doctorId} value={doc.firstName}>
                    {doc.firstName} {doc.lastName || ""}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item label="Patient Name" style={{ flex: "1 1 180px" }}>
              <Input
                placeholder="Enter patient name"
                value={filters.patientName}
                onChange={(e) =>
                  setFilters((prev) => ({
                    ...prev,
                    patientName: e.target.value,
                  }))
                }
              />
            </Form.Item>

            <div
              style={{
                display: "flex",
                justifyContent: "end",
                gap: "8px",
                flex: "1 1 160px",
                alignItems: "center",
              }}
            >
              <Button type="primary" onClick={handleSearch}>
                Search
              </Button>
              <Button onClick={handleReset}>Reset</Button>
            </div>
          </div>
        </Form>
      </div>

      <Table
        dataSource={Array.isArray(bookings) ? bookings : []}
        columns={columns}
        rowKey={(record) => record.appointmentId || Math.random()}
        loading={loading || searchLoading}
        pagination={{ pageSize: 10 }}
        style={{ marginTop: 16, background: "#fff", borderRadius: 8 }}
      />

      <Modal
        title="Create Booking"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        style={{ top: 20 }}
        width={800}
        bodyStyle={{
          maxHeight: "80vh",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        <Steps
          current={currentStep}
          onChange={(step) => setCurrentStep(step)}
          style={{ marginBottom: 24 }}
        >
          {steps.map((item) => (
            <Step key={item.title} title={item.title} />
          ))}
        </Steps>

        <div>{steps[currentStep].content}</div>

        <div style={{ marginTop: 24, textAlign: "right" }}>
          {currentStep > 0 && (
            <Button style={{ marginRight: 8 }} onClick={prev}>
              Previous
            </Button>
          )}
          {currentStep < steps.length - 1 && (
            <Button type="primary" onClick={next}>
              Next
            </Button>
          )}
          {currentStep === steps.length - 1 && (
            <Button type="primary" onClick={handleSubmit} loading={submitting}>
              {submitting ? "Submitting..." : "Submit"}
            </Button>
          )}
        </div>
      </Modal>

      <RescheduleBookingModal
        open={rescheduleModal.open}
        booking={rescheduleModal.record}
        onClose={() => setRescheduleModal({ open: false, record: null })}
        branchId={selectedBranchId}
        handleSearch={handleSearch}
        isSearchActive={isSearchActive}
      />

      <CancelBookingModal
        open={cancelModal.open}
        booking={cancelModal.record}
        onClose={() => setCancelModal({ open: false, record: null })}
        branchId={selectedBranchId}
        handleSearch={handleSearch}
        isSearchActive={isSearchActive}
      />
    </div>
  );
};

export default BookingDashboard;
